import { type AxiosError } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import {
  NotepadControllerV2ApiFactory,
  type NotepadV2Entry,
} from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../../base-api-communication'
import { useGlobalConfigContext } from '../../../global-config'

const getLanguageNotepadV2TenantUpidPutMutationKey = (): string =>
  'LangugageNotepadV2TenantUpidPutMutation'

export const useLanguageNotepadV2TenantUpidPutMutation = ({
  onSuccess,
}: {
  onSuccess: () => void
}): SWRMutationResponse<
  NotepadV2Entry,
  AxiosError,
  string,
  { upid: string }
> => {
  const config = useGlobalConfigContext()
  const client = useBullyApi(NotepadControllerV2ApiFactory)

  return useSWRMutation(
    getLanguageNotepadV2TenantUpidPutMutationKey(),
    async (swrKey: string, data: { arg: { upid: string } }) => {
      const response = await client.languageNotepadV2TenantUpidPut({
        language: config.language,
        tenant: config.tenantAndEnv,
        upid: data.arg.upid,
      })

      return response.data
    },
    {
      onSuccess,
    },
  )
}
